import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "motion/react";
import { ElementsMenuContainer } from "../../containers/elementsMenuContainer";
import { UsersMenuContainer } from "../../containers/usersMenuContainer";
import { InfoModalContainer } from "../../containers/infoModalContainer";
import { SimMenuContainer } from "../../containers/simMenuContainer";
import { VizMenuContainer } from "../../containers/vizMenuContainer";
import HelpMenu from "../HelpMenu";
import ElementsIcon from "../ElementsIcon";
import UsersIcon from "../UsersIcon";
import InviteIcon from "../InviteIcon";
import HelpIcon from "../HelpIcon";
import SimIcon from "../SimIcon";
import VizIcon from "../VizIcon";
import "./styles.css";

const Menu = ({ sessionType, onToggleInfoModal, isShowingInfoModal, engine, isLlmActive }) => {
  const [activeMenu, setActiveMenu] = useState("invite");

  const handleMenuClick = (menuName) => {
    setActiveMenu((prev) => (prev === menuName ? null : menuName));
  };

  const menuPosition = isLlmActive ? "-70%" : "-50%";

  const menuContainerVariants = {
    initial: { opacity: 0, x: 50, y: menuPosition },
    animate: { opacity: 1, x: 0, y: menuPosition, transition: { duration: 0.3, ease: "easeOut" } },
    exit: { opacity: 0, x: 50, y: menuPosition, transition: { duration: 0.3, ease: "easeOut" } },
  };

  useEffect(() => {
    if (!isShowingInfoModal && activeMenu !== null) {
      setActiveMenu(null);
    }
  }, [isShowingInfoModal]);

  useEffect(() => {
    const isAnyMenuOpen = activeMenu !== null;
    if (isAnyMenuOpen !== isShowingInfoModal) {
      onToggleInfoModal();
    }
  }, [activeMenu]);

  return (
    <>
      <div className="column side-menu">
        {sessionType === "ATOMS" && (
          <>
            {engine !== "VIEWONLY" && (
              <SimIcon isActive={activeMenu === "sim"} handleClick={() => handleMenuClick("sim")} />
            )}
            <VizIcon
              isActive={activeMenu === "viz"}
              handleClick={() => handleMenuClick("viz")}
              withMargin={engine !== "VIEWONLY"}
            />
          </>
        )}
        {sessionType === "ELEMENTS" && (
          <ElementsIcon isActive={activeMenu === "elements"} handleClick={() => handleMenuClick("elements")} />
        )}
        <UsersIcon isActive={activeMenu === "users"} handleClick={() => handleMenuClick("users")} />
        <InviteIcon handleClick={() => handleMenuClick("invite")} isActive={activeMenu === "invite"} />
        <HelpIcon handleClick={() => handleMenuClick("help")} isActive={activeMenu === "help"} />
      </div>

      <AnimatePresence mode="popLayout">
        {activeMenu === "elements" && (
          <ElementsMenuContainer
            key="elements"
            onClose={() => handleMenuClick("elements")}
            variants={menuContainerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
        )}
        {activeMenu === "users" && (
          <UsersMenuContainer
            key="users"
            onClose={() => handleMenuClick("users")}
            variants={menuContainerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
        )}
        {activeMenu === "invite" && (
          <InfoModalContainer
            key="invite"
            onClose={() => handleMenuClick("invite")}
            variants={menuContainerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
        )}
        {activeMenu === "sim" && (
          <SimMenuContainer
            key="sim"
            onClose={() => handleMenuClick("sim")}
            variants={menuContainerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
        )}
        {activeMenu === "viz" && (
          <VizMenuContainer
            key="viz"
            onClose={() => handleMenuClick("viz")}
            variants={menuContainerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
        )}
        {activeMenu === "help" && (
          <HelpMenu
            key="help"
            onClose={() => handleMenuClick("help")}
            variants={menuContainerVariants}
            initial="initial"
            animate="animate"
            exit="exit"
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default Menu;
